import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY');
}

// auth-flow-hardening Inc-2 (2026-05-20): explicit auth config.
//
// `flowType: 'pkce'` is the documented Arcanum auth flow (the SDK default
// is also 'pkce' in @supabase/supabase-js ^2.47.0; setting it explicitly
// makes the intent visible and prevents an SDK-version downgrade from
// silently flipping back to 'implicit').
//
// `detectSessionInUrl: true` auto-detects + exchanges the `?code=...`
// query param OR the `#access_token=...` hash on initial page load,
// populating localStorage with the session before the React tree mounts.
// This is what makes the auth/callback + reset-password recovery flows
// work without an explicit exchangeCodeForSession call at every site —
// EXCEPT for the recovery flow, which the `reset-password.tsx` page
// explicitly subscribes to `onAuthStateChange` for `PASSWORD_RECOVERY`
// because Supabase fires that event separately from a normal SIGNED_IN.
//
// `autoRefreshToken: true` + `persistSession: true` are the SDK defaults
// but pinned here so they survive any future SDK option-name shuffle.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    autoRefreshToken: true,
    persistSession: true,
  },
});
